import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const GoogleLogo = ({ title = '', ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || 'Google'}</title>

      <g clipPath="url(#clip0)">
        <path
          d="M17.2001 8.59259C17.2001 8.02159 17.1528 7.44749 17.0521 6.88574H8.96851V10.1204H13.5976C13.4055 11.1637 12.7883 12.0866 11.8845 12.673V14.7718H14.6462C16.268 13.3088 17.2001 11.1482 17.2001 8.59259Z"
          fill="#4285F4"
        />

        <path
          d="M8.96847 16.8001C11.2798 16.8001 13.2291 16.0563 14.6493 14.7723L11.8876 12.6734C11.1192 13.1858 10.1273 13.4759 8.97161 13.4759C6.73581 13.4759 4.84011 11.9975 4.15992 10.0098H1.31006V12.1734C2.7649 15.0099 5.72813 16.8001 8.96847 16.8001Z"
          fill="#34A853"
        />

        <path
          d="M4.15679 10.0097C3.7978 8.96646 3.7978 7.83679 4.15679 6.79354V4.62988H1.31008C0.0945574 7.00343 0.0945574 9.79983 1.31008 12.1734L4.15679 10.0097Z"
          fill="#FBBC04"
        />

        <path
          d="M8.96847 3.32379C10.1903 3.30527 11.3712 3.7559 12.256 4.58309L14.7028 2.18486C13.1535 0.758877 11.0972 -0.0251028 8.96847 -0.000410496C5.72813 -0.000410496 2.7649 1.78978 1.31006 4.62939L4.15677 6.79305C4.83381 4.80224 6.73266 3.32379 8.96847 3.32379Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16.8" height="16.8" fill="white" transform="translate(0.399902)" />
        </clipPath>
      </defs>
    </svg>
  );
};

GoogleLogo.propTypes = {
  title: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(GoogleLogo);
